(function () {
  'use strict';

  function initBundle(form) {
    const radios = form.querySelectorAll('.nb-bundle__radio');
    const qtyInput = form.querySelector('[data-nb-bundle-qty]');
    const atcBtn = form.querySelector('[data-nb-bundle-atc]');
    const atcLabel = form.querySelector('.nb-bundle__atc-label');
    const atcSpinner = form.querySelector('.nb-bundle__atc-spinner');
    const errorEl = form.querySelector('[data-nb-bundle-error]');
    const originalLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

    // Live summary block driven by selected tier's data attributes.
    const sumTitle    = form.querySelector('[data-nb-bundle-title]');
    const sumSubtitle = form.querySelector('[data-nb-bundle-subtitle]');
    const sumPriceNow = form.querySelector('[data-nb-bundle-price-now]');
    const sumPriceStrike = form.querySelector('[data-nb-bundle-price-strike]');
    const sumPriceSaved = form.querySelector('[data-nb-bundle-price-saved]');
    const sumGift     = form.querySelector('[data-nb-bundle-gift]');
    const sumGiftText = form.querySelector('[data-nb-bundle-gift-text]');

    const bundleRoot = form.closest('.nb-bundle');
    const mobileBar = bundleRoot ? bundleRoot.querySelector('[data-nb-mobile-atc]') : null;
    // Reparent to <body> so position:fixed isn't broken by ancestors with
    // transform/filter/will-change (Dawn wraps product info in such an element).
    if (mobileBar && mobileBar.parentNode !== document.body) {
      document.body.appendChild(mobileBar);
    }
    const mobileTier = mobileBar ? mobileBar.querySelector('[data-nb-mobile-atc-tier]') : null;
    const mobilePrice = mobileBar ? mobileBar.querySelector('[data-nb-mobile-atc-price]') : null;
    const mobileStrike = mobileBar ? mobileBar.querySelector('[data-nb-mobile-atc-strike]') : null;
    const mobileBtn = mobileBar ? mobileBar.querySelector('[data-nb-mobile-atc-btn]') : null;
    const mobileBtnOriginalLabel = mobileBtn ? mobileBtn.textContent.trim() : 'Get Protected';

    function readSelected() {
      const sel = Array.from(radios).find((r) => r.checked) || radios[0];
      if (!sel) return null;
      const d = sel.dataset;
      const discPct = parseInt(d.tierDiscountPct || '0', 10) || 0;
      return {
        sel: sel,
        tier: d.tierTitle || '',
        subtitle: d.tierSubtitle || '',
        priceNow: d.tierPriceNow || '',
        priceStrike: d.tierPriceStrike || '',
        priceSaved: d.tierPriceSaved || '',
        discountPct: discPct,
        giftText: d.tierGiftText || '',
        qty: parseInt(d.tierQty || '2', 10),
        giftId: parseInt(d.giftId || '0', 10),
        tierIndex: sel.value,
      };
    }

    function syncSummary(state) {
      if (!state) return;
      if (sumTitle) sumTitle.textContent = state.tier;
      if (sumSubtitle) sumSubtitle.textContent = state.subtitle;
      if (sumPriceNow) sumPriceNow.textContent = state.priceNow;
      if (sumPriceStrike) sumPriceStrike.textContent = state.priceStrike;
      if (sumPriceSaved) {
        sumPriceSaved.textContent = state.discountPct
          ? 'Save ' + state.discountPct + '%'
          : '';
      }
      if (sumGift && sumGiftText) {
        if (state.giftText) {
          sumGiftText.textContent = state.giftText;
          sumGift.hidden = false;
        } else {
          sumGiftText.textContent = '';
          sumGift.hidden = true;
        }
      }
    }

    function syncMobileBar(state) {
      if (!mobileBar || !state) return;
      if (mobileTier) mobileTier.textContent = state.tier;
      if (mobilePrice) mobilePrice.textContent = state.priceNow;
      if (mobileStrike) mobileStrike.textContent = state.priceStrike;
    }

    function syncSelected() {
      radios.forEach((r) => {
        const wrap = r.closest('.nb-bundle__pill-wrap');
        if (r.checked) {
          if (wrap) wrap.classList.add('nb-bundle__pill-wrap--selected');
          if (qtyInput) qtyInput.value = r.dataset.tierQty || '2';
        } else {
          if (wrap) wrap.classList.remove('nb-bundle__pill-wrap--selected');
        }
      });
      const state = readSelected();
      syncSummary(state);
      syncMobileBar(state);
      // Broadcast bundle state so the sticky bar (and future
      // listeners: analytics, header mini-cart, etc.) can react without
      // re-scraping the DOM.
      if (state) {
        form.dispatchEvent(new CustomEvent('nb-bundle:change', {
          bubbles: true,
          detail: state,
        }));
      }
    }

    // React to both `change` (keyboard / programmatic) and label clicks.
    radios.forEach((r) => r.addEventListener('change', syncSelected));
    syncSelected();

    // Mobile sticky bar: forward clicks to the real form submit, and
    // show the bar only when the inline ATC button is off-screen.
    if (mobileBtn) {
      mobileBtn.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    }

    // Sticky-bar visibility — show only in the middle scroll range:
    // hidden while the in-page bundle picker is on screen (redundant
    // CTA), and hidden once the user reaches the footer (so the bar
    // doesn't overlay footer links / policy text).
    if (mobileBar && form && 'IntersectionObserver' in window) {
      let pickerInView = true;
      let footerInView = false;

      const applyVisibility = () => {
        const showBar = !pickerInView && !footerInView;
        mobileBar.dataset.visible = showBar ? 'true' : 'false';
        mobileBar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
      };

      new IntersectionObserver((entries) => {
        entries.forEach((e) => { pickerInView = e.isIntersecting; });
        applyVisibility();
      }, { rootMargin: '0px', threshold: 0 }).observe(form);

      const footerEl = document.querySelector('footer.footer, .footer, footer');
      if (footerEl) {
        new IntersectionObserver((entries) => {
          entries.forEach((e) => { footerInView = e.isIntersecting; });
          applyVisibility();
        }, { rootMargin: '0px', threshold: 0 }).observe(footerEl);
      }

      applyVisibility();
    }

    function getSelected() {
      return Array.from(radios).find((r) => r.checked) || radios[0];
    }

    function setBusy(busy) {
      if (atcBtn) {
        atcBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
        atcBtn.disabled = !!busy;
        if (atcSpinner) atcSpinner.hidden = !busy;
        if (atcLabel) atcLabel.textContent = busy ? 'Adding…' : originalLabel;
      }
      if (mobileBtn) {
        mobileBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
        mobileBtn.disabled = !!busy;
        mobileBtn.textContent = busy ? 'Adding…' : mobileBtnOriginalLabel;
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      showError('');
      const sel = getSelected();
      if (!sel) return;

      const variantId = parseInt(form.querySelector('input[name="id"]').value, 10);
      const qty = parseInt(sel.dataset.tierQty || '2', 10) || 2;
      const giftId = parseInt(sel.dataset.giftId || '0', 10);

      if (!variantId) {
        showError('Product variant unavailable. Please refresh the page.');
        return;
      }

      const items = [{ id: variantId, quantity: qty }];
      if (giftId) items.push({ id: giftId, quantity: 1 });

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      setBusy(true);
      const controller = new AbortController();
      // Timeout safeguard — never spin longer than 15s.
      const timer = setTimeout(() => controller.abort(), 15000);

      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
          signal: controller.signal,
        });
        clearTimeout(timer);

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Could not add to cart (status ' + res.status + ').');
        }
        // Skip cart — go straight to checkout.
        window.location.href = root + 'checkout';
      } catch (err) {
        clearTimeout(timer);
        const msg = err.name === 'AbortError'
          ? 'Request timed out. Please try again.'
          : (err.message || 'Could not add to cart. Please try again.');
        showError(msg);
        setBusy(false);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-nb-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
